import React from 'react';

import AppRouter from './routes';
import AuthInitializer from './app/AuthInitializer';
import { ModalProvider } from './shared/components/ModalProvider';

function App() {
  return (
    <ModalProvider>
      <AuthInitializer>
        <AppRouter />
      </AuthInitializer>
    </ModalProvider>
  );
}

export default App;